import React, { useContext, useReducer } from "react";

export const profileUpdateInitialState = {
  onUpdateCompleted: undefined,
  onUpdateError: undefined,
  isUpdatingProfile: false,
  profileRefetches: {
    // obj {
    //  [refetchKey]: refetchPromiseFn,
    //   Example properties
    //  "matchHistory": refetch,
    //  "rankBlock": () => Promise.resolve({some data});
    // }
    // Why functions that return promises?
    // - We will execute all functions at once when necessary (after update is complete)
    //   Promises will allows us to know when all refetching is done using Promise.all
  },
};

export function updateReducer(state, action) {
  switch (action.type) {
    case "isUpdatingProfile":
      return { ...state, isUpdatingProfile: action.payload };
    case "onCompleted":
      return { ...state, onUpdateCompleted: action.payload };
    case "onError":
      return { ...state, onUpdateError: action.payload };
    case "addUpdates":
      if (!!action.payload && action.payload.constructor === Object) {
        return {
          ...state,
          profileRefetches: {
            ...state.profileRefetches,
            ...action.payload,
          },
        };
      } else {
        return state;
      }
    case "resetUpdates":
      return { ...state, ...profileUpdateInitialState };
    default:
      return state;
  }
}

export const UpdateDispatchContext = React.createContext();
export const UpdateStateContext = React.createContext();

export function SummonerProfileUpdateProvider(props) {
  const [state, dispatch] = useReducer(updateReducer, profileUpdateInitialState);

  return (
    <UpdateDispatchContext.Provider value={dispatch}>
      <UpdateStateContext.Provider value={state}>{props.children}</UpdateStateContext.Provider>
    </UpdateDispatchContext.Provider>
  );
}
